import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';

interface ICompanySubmissionsBlackListUpdateDrawerObject {
  formObject: DynamicForm;
  toggleVisibility: () => void;
  action: () => void;
}

export const getCompanySubmissionsBlackListUpdateDrawerObject = ({
  formObject,
  toggleVisibility,
  action,
}: ICompanySubmissionsBlackListUpdateDrawerObject): DrawerObject => {
  return {
    title: 'settings.blackList.update.title',
    width: '30vw',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    actions: [
      {
        label: 'settings.blackList.update.cancel',
        onClick: () => toggleVisibility(),
      },
      {
        label: 'settings.blackList.update.update',
        onClick: () => action(),
      },
    ],
  };
};
